import xss, { getDefaultWhiteList } from "xss";

export const ehqWhiteListAttributes = [
  "id",
  "class",
  "style",
  "width",
  "height",
  "title",
  "role"
];

/**
 * Remove all dangerous html tags
 * @param str
 */
export const stripDangerousHtml = (str: string): string => {
  return xss(str, {
    whiteList: {
      ...getDefaultWhiteList(),
      h1: ehqWhiteListAttributes,
      h2: ehqWhiteListAttributes,
      h3: ehqWhiteListAttributes,
      h4: ehqWhiteListAttributes,
      h5: ehqWhiteListAttributes,
      h6: ehqWhiteListAttributes,
      span: ehqWhiteListAttributes,
      p: ehqWhiteListAttributes,
      ol: ehqWhiteListAttributes,
      ul: ehqWhiteListAttributes,
      li: ehqWhiteListAttributes,
      table: [...ehqWhiteListAttributes, "border", "align", "valign"],
      tbody: [...ehqWhiteListAttributes, "align", "valign"],
      tr: [...ehqWhiteListAttributes, "rowspan", "align", "valign"],
      td: [...ehqWhiteListAttributes, "rowspan", "colspan", "align", "valign"],
      img: [...ehqWhiteListAttributes, "src", "alt"],
      iframe: [...ehqWhiteListAttributes, "src", "allowfullscreen"],
      style: []
    },
    stripIgnoreTag: true
  });
};

/**
 * Remove all html tags and convert into plaintext
 * @param str
 */
export const stripAllHtml = (str: string): string => {
  return xss(str, {
    whiteList: {},
    stripIgnoreTag: true,
    stripBlankChar: true,
    stripIgnoreTagBody: ["style"]
  });
};
